<template>
  <!-- 开宝箱 -->
  <div class="open-box-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    'background-image': `url(${cc.template_bg})`
    }">
    <div class="box" :style="{'background-image': `url(${cc.box_bg})`}">
      <div class="box-num" :style="{'color': gc.text_color, 'background': cc.num_bg_color}">{{score_left}}</div>
      <div class="prize" @click="showPrizeListModal" :style="{'color': gc.main_color}">点击查看宝箱内容</div>
    </div>
    <div class="open-btn" :style="{'background-image': `url(${cc.btn_bg})`}" @click="openBox"></div>
    <Modal ref="prize-modal" :width="299" :gc="gc" :cc="cc" :title="award.name === '谢谢参与' ? '谢谢参与' : '恭喜中奖'">
      <div class="prize-modal-wrapper modal-content">
        <template v-if="award.name !== '谢谢参与'">
          <div class="prize-lottery-item modal-item" :class="'color-' + award.rarity">
            <div class="prize-name">
              <p>{{award.name}}</p>
            </div>
            <div class="image-box">
              <img :src="award.img_url" alt="">
              <div :class="'image-cover color-' + award.rarity"></div>
            </div>
            <p class="tag">{{['隐秘', '传说', '史诗', '稀有', '普通'][award.rarity-1]}}</p>
          </div>
        </template>
        <div class="no-price" v-else>
          <img src="https://imgheybox.max-c.com/oa/2022/07/29/fd2176f28f0566cf782269a7e6ca2bb1.png" alt="">
        </div>
        <p class="distribute-desc" :style="{'color':  hexToRgba(gc.main_color, .8),'margin-top': '12px'}">{{notify_content}}</p>
        <div class="btn-done" @click="closePrizeModal" :style="{'background': cc.modal_btn_bg || gc.modal_confirm_btn_big? `url(${cc.modal_btn_bg || gc.modal_confirm_btn_big}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color}">确认</div>
      </div>
    </Modal>
    <two-btn-modal title="前置任务" confirm_btn_text="去完成" :desc="modal_desc" :cc="cc" :gc="gc" @callback="executeFrontTaskProtocol" ref="front-task-modal"/>
    <!-- 奖池大赏 -->
    <fade-modal ref="prize-list-modal" title="奖池大赏" :desc="cc.prize_list_desc" :gc="gc" :bg="gc.content_bg">
      <div class="prize-list-cate-wrapper colors" v-if="prize_type_list && prize_type_list.length > 0">
        <div class="prize-list-cate-item" :class="'color-'+item.rarity" v-for="(item, index) in prize_type_list" :key="item.text" v-show="item.list.length > 0"
          :style="{
            'border-top': index != 0 && item.list.length > 0 ? `1px solid ${hexToRgba(cc.box_bg, .2)}` : '' 
          }">
          <span class="tag">{{item.text}}奖品  {{cc.probability[item.rarity]}}</span>
          <div class="prize-list">
            <div class="prize-item" v-for="prize in item.list" :key="prize.award_id">
              <div class="prize-card">
                <div class="prize-cover"></div>
                <div class="prize-image">
                  <img :src="prize.img" alt="">
                </div>
                <div class="prize-price"><p><span>参考价：</span><span v-if="prize.price">¥</span><span class="large">{{prize.price || '-'}}</span></p></div>
              </div>
              <p class="prize-name" :style="{color: gc.main_color}">{{prize.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <no-data v-else :color="gc.main_color" desc="暂时没有奖品哦～" style="padding-bottom: 20px"/>
    </fade-modal>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin'
import { utils } from '_lib/utils'
import { openBox } from '_api/activity-common-template'
import FadeModal from './FadeModal'
export default {
  name: 'cpt-open-box',
  mixins: [ComponentCommonMixin],
  components: { FadeModal },
  data () {
    return {
      front_task_jump_protocol: '',
      award: {},
      score_left: 0,
      notify_content: '',
      modal_desc: '',
    }
  },
  computed: {
    // 奖品列表
    box_list () {
      return this.cd.box_list || []
    },
    // 所有奖品，按等级分类
    prize_type_list () {
      const list = [
        {text: '隐秘', rarity: 1, list: []}, 
        {text: '传说', rarity: 2, list: []}, 
        {text: '史诗', rarity: 3, list: []}, 
        {text: '稀有', rarity: 4, list: []}, 
        {text: '普通', rarity: 5, list: []}
      ]
      this.box_list.forEach(item => {
        list[item.rarity - 1].list.push(item)
      })
      return list
    }
  },
  mounted () {
    this.score_left = this.cd.box_left
  },
  methods: {
    openBox () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      openBox({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.cd.act_id,
        task_os_type: this.querys.task_os_type,
        client_version: this.querys.version
      }).then(res => {
        if (res.data.status == 'ok') {
          const data = res.data.result
          if (data.type == 'front_task_error') {
            this.front_task_jump_protocol = data.jump_protocol
            this.modal_desc = data.error_msg
            this.showBindModal()
          } else {
            this.award = data.award_list[0]
            this.notify_content = this.award.name === '谢谢参与' ? '很遗憾，未中奖' : (data.notify_content || '')
            this.score_left = this.award.left_count
            this.$nextTick(() => {
              this.showPrizeModal()
            })
          }
        }
      })
    },
    executeFrontTaskProtocol () {
      if (this.front_task_jump_protocol) {
        this.closeBindModal()
        utils.executeProtocol(this.front_task_jump_protocol)
      }
    },
    showPrizeModal () {
      this.$refs['prize-modal'].showModal()
    },
    closePrizeModal () {
      this.$refs['prize-modal'].hideModal()
    },
    showBindModal () {
      this.$refs['front-task-modal'].$refs['modal'].showModal()
    },
    closeBindModal () {
      this.$refs['front-task-modal'].$refs['modal'].hideModal()
    },
    showPrizeListModal () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.$refs['prize-list-modal'].showModal()
    },
  }
}
</script>

<style lang="less" scoped>
@import "../style/lottery-item-v2.less";
.open-box-container {
  padding: 26px 50px 24px;
  margin: 32px 14px 0;
  background-size: 100% 100%;
  .box {
    width: 241px;
    height: 169px;
    margin: 0 auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .box-num {
      position: absolute;
      top: 13px;
      right: 27px;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      text-align: center;
      font-family: 'Alibaba PuHuiTi 2.0';
      font-weight: 800;
      font-size: 15px;
      z-index: 1;
      background: #E0645C
    }
    .prize {
      position: absolute;
      left: 50%; 
      bottom: 6px;
      transform: translateX(-50%) scale(.667);
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      text-decoration-line: underline;
    }
  }
  .open-btn {
    width: 229px;
    height: 36px;
    background-size: cover;
    margin: 17px auto 0;
  }
  .prize-modal-wrapper {
    width: 100%;
    .no-price {
      height: 112px;
      margin: 0 auto;
      width: 169px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .split-line {
      margin-top: 12px;
    }
    .lottery-item {
      height: 112px;
      margin: 12px auto 0;
      .prize-name {
        align-items: center;
        display: flex;
        height: 16px;
        justify-content: center;
        width: 100%;
        p {
          font-size: 11px;
          height: 11px;
          line-height: 11px;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .image-box {
        border-radius: 2px;
        height: 77px;
        margin-top: 4px;
        overflow: hidden;
        position: relative;
        width: 100%;
        img {
          height: 100%;
          object-fit: contain;
          width: 100%;
        }
        .tag {
          bottom: -42%;
          color: #ffffff;
          font-size: 11px;
          height: 20px;
          line-height: 20px;
          position: absolute;
          right: 0px;
          text-align: center;
          transform: rotate(-45deg) translateX(50%);
          width: 100px;
        }
      }
    }
  }
  .prize-list-cate-wrapper {
    -webkit-overflow-scrolling: touch;
    height: 100%;
    padding: 0 14px;
    width: 100%;
    z-index: 100;
    .prize-list-cate-item {
      background-color: transparent;
      border: none;
      .tag {
        color: #ffffff;
        display: block;
        font-size: 12px;
        font-weight: 500;
        padding: 2px 0 2px 6px;
      }
      .prize-list {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 14px;
        margin-top: 6px;
        overflow: hidden;
        width: 100%;
        .prize-item {
          margin: 0 8px 10px 0;
          width: calc(33.333333% - 8px);
          .prize-name {
            font-size: 12px;
            line-height: 17px;
            margin-top: 3px;
          }
          .prize-card {
            background: rgba(20,25,30,0.8);
            border-radius: 2px;
            height: 73px;
            position: relative;
            width: 100%;
            .prize-cover {
              bottom: 0;
              height: 30px;
              left: 0;
              position: absolute;
              width: 100%;
            }
            .prize-image {
              border-top-left-radius: 2px;
              border-top-right-radius: 2px;
              height: 56px;
              overflow: hidden;
              width: 100%;
              img {
                display: block;
                height: 100%;
                object-fit: cover;
                width: 100%;
              }
            }
            .prize-price {
              color: #ffffff;
              height: 17px;
              position: relative;
              p {
                font-size: 18px;
                height: 32px;
                overflow: hidden;
                padding: 4px 10px;
                text-overflow: ellipsis;
                transform-origin: top left;
                transform: scale(0.5);
                white-space: nowrap;
                width: 200%;
                span {
                  display: inline-block;
                  vertical-align: top;
                }
                span.large {
                  font-size: 24px;
                  font-weight: 600;
                  position: relative;
                  top: -4px;
                }
              }
            }
          }
        }
      }
    }
    .prize-list-cate-item.color-1 {
      .tag {
        background: linear-gradient(90deg, #eb3f27 0%, rgba(235,63,39,0) 100%);
      }
      .prize-cover {
        background: linear-gradient(360deg, rgba(235,63,39,0.4) 0%, rgba(235,63,39,0) 100%);
      }
    }
    .prize-list-cate-item.color-2 {
      .tag {
        background: linear-gradient(90deg, #fcae1f 0%, rgba(252,174,31,0) 100%);
      }
      .prize-cover {
        background: linear-gradient(360deg, rgba(253,160,20,0.4) 0%, rgba(253,160,20,0) 100%);
      }
    }
    .prize-list-cate-item.color-3 {
      .tag {
        background: linear-gradient(90deg, #7a60ff 0%, rgba(122,96,255,0) 100%);
      }
      .prize-cover {
        background: linear-gradient(360deg, rgba(122,96,255,0.4) 0%, rgba(122,96,255,0) 100%);
      }
    }
    .prize-list-cate-item.color-4 {
      .tag {
        background: linear-gradient(90deg, #00b1fb 0%, rgba(0,177,251,0) 100%);
      }
      .prize-cover {
        background: linear-gradient(360deg, rgba(0,177,251,0.4) 0%, rgba(0,177,251,0) 100%);
      }
    }
    .prize-list-cate-item.color-5 {
      .tag {
        background: linear-gradient(90deg, #2ead57 0%, rgba(46,173,87,0) 100%);
      }
      .prize-cover {
        background: linear-gradient(360deg, rgba(46,173,87,0.4) 0%, rgba(46,173,87,0) 100%);
      }
    }
  }
}
</style>